import React from 'react'
import { useTranslation } from 'react-i18next'

interface User {
  username: string
}

interface TrainingItem {
  guid: string
  startTime: string
  endTime?: string | null
  user: User
  resultStatus?: string | null
  details?: string
}

interface TrainingHistoryTableProps {
  trainingData?: TrainingItem[]
}

const statusLabel = (val?: string | null) => {
  switch ((val || '').toString()) {
    case 'Success':
      return { label: 'Успех', className: 'match' }
    case 'Failed':
      return { label: 'Ошибка', className: 'no-match' }
    case 'In_progress':
      return { label: 'Обучение', className: 'processing' }
  }
}

const formatCustomDateTime = (isoString: string): string => {
  const d = new Date(isoString)
  if (isNaN(d.getTime())) return '—'

  const pad = (n: number) => String(n).padStart(2, '0')
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}/${pad(
    d.getHours(),
  )}:${pad(d.getMinutes())}`
}

export const TrainingHistoryTable: React.FC<TrainingHistoryTableProps> = ({
  trainingData,
}) => {
  const { t } = useTranslation()
  return (
    <div className="option-page-content">
      <span>{t('Прошлое обучение')}:</span>
      <div>
        <div className="option-page-header">
          <p className="option-page-start">{t('Дата/время запуска')}:</p>
          <p className="option-page-initiator">{t('Инициатор')}:</p>
          <p className="option-page-status">{t('Статус')}</p>
          <p className="option-page-error">{t('Причина ошибки')}</p>
          <p className="option-page-end">{t('Дата/время окончания')}</p>
        </div>
        {trainingData?.map((item) => {
          const status = statusLabel(item.resultStatus)
          return (
            <div className="option-page-table" key={item.guid}>
              <p className="option-page-start">
                {formatCustomDateTime(item.startTime)}
              </p>
              <p className="option-page-initiator">{item.user.username}</p>
              <p className={`option-page-status ${status?.className}`}>
                {status?.label}
              </p>
              <p className="option-page-error">{item.details || ''}</p>
              <p className="option-page-end">
                {item.endTime ? formatCustomDateTime(item.endTime) : ''}
              </p>
            </div>
          )
        })}
      </div>
    </div>
  )
}
